import { useCallback, useEffect, useState } from 'react';
import { useReactFlow, useStore } from '@xyflow/react';
import styles from './styles.module.css';
import { Input, Select, SelectItem, Textarea } from '@nextui-org/react';

const NodeAttributesPanel = ({ actionsList }: { actionsList: any }) => {
  const { setNodes } = useReactFlow();
  const selectedNode = useStore(useCallback((state) =>
    state.nodes.find((node) => node.selected)
    , []));

  const [toolsList, setToolsList] = useState<any[]>([]);

  useEffect(() => {
    if (actionsList.length > 0) {
      const actions = (actionsList ?? []).map((action: any) => action.name);
      const tool = [
        'SNSTool',
        'S3ReaderTool'
      ]
      setToolsList([...tool, ...actions]);
    }
  }, [actionsList])

  if (!selectedNode) {
    return (
      <div className={styles.panel}>
        <h4>Properties</h4>
        <p className={styles.empty}>Select a node to edit properties</p>
      </div>
    );
  }

  const updateNodeData = (key: string, value: any) => {
    setNodes(nodes =>
      nodes.map(node => {
        if (node.id !== selectedNode.id) return node;

        let newData = { ...node.data };

        switch (key) {
          case 'name':
            newData = { ...newData, name: value, label: value };
            break;
          case 'variables': {
            const varKey = selectedNode.data.tools?.[0] === 'SNSTool' ? 'sns_arn' : 'bucket_name';
            newData = { ...newData, variables: { [varKey]: value }, variable: value };
            break;
          }
          case 'tools':
            newData = { ...newData, tools: [value] };
            delete newData?.['variables'];
            delete newData?.['variable'];
            break;
          default:
            newData = { ...newData, [key]: value };
            break;
        }

        return { ...node, data: newData };
      })
    );
  };

  return (

    <div className={styles.panel}>
      <h4>Properties</h4>
      <div >
        <label htmlFor="node-name" className='text-sm'>Name<span className="text-red-500">*</span></label>
        <Input
          id="node-name"
          type="text"
          radius='sm'
          value={typeof selectedNode?.data?.label === 'string' ? selectedNode?.data?.label : ''}
          onChange={e => updateNodeData('name', e.target.value)}
          placeholder="Enter name"
        />
      </div>
      <div>
        <label htmlFor="node-goal" className='text-sm'>goal<span className="text-red-500">*</span></label>
        <Textarea
          id='goal-textarea'
          radius='sm'
          value={typeof selectedNode?.data?.goal === 'string' ? selectedNode?.data?.goal : ''}
          onChange={e => updateNodeData('goal', e.target.value)}
          placeholder="Enter goal"
        />
      </div>
      <div className={styles.field}>
        <label htmlFor="node-tools">Tools</label>
        <Select
          size="sm"
          placeholder="Select tools"
          selectedKeys={new Set(selectedNode?.data?.tools ?? [''])}
          disallowEmptySelection={true}
          onSelectionChange={(keys) => {
            const security = Array.from(keys)[0];
            updateNodeData('tools', security);
          }}
          aria-label="tools-data"
          id="node-tools"
        >
          {toolsList.map((skill) => (
            <SelectItem key={skill} value={skill}>
              {skill}
            </SelectItem>
          ))}
        </Select>
      </div>
      {(selectedNode?.data?.tools?.[0] === 'SNSTool' || selectedNode?.data?.tools?.[0] === 'S3ReaderTool') && <div className={styles.field}>
        <label htmlFor="node-attr">{selectedNode?.data?.tools?.[0] === 'SNSTool' ? 'SNS ARN' : 'Bucket name'}<span className="text-red-500">*</span></label>
        <input
          id="node-attr"
          type="text"
          value={typeof selectedNode?.data?.variable === 'string' ? selectedNode?.data?.variable : ''}
          onChange={e => updateNodeData("variables", e.target.value)}
          placeholder="Enter value"
        />
      </div>}
      <div className={styles.field}>
        <label htmlFor="node-color">Color</label>
        <input
          id="node-color"
          type="color"
          value={typeof selectedNode.data.color === 'string' ? selectedNode.data.color : '#ffffff'}
          onChange={e => updateNodeData('color', e.target.value)}
        />
      </div>
    </div>

  );
};

export default NodeAttributesPanel;
